export const isNewProduct = (dateString) => {
  const productDate = new Date(dateString);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  return productDate >= oneMonthAgo;
};
